import React from "react";
import ReactDOM from "react-dom";
import Favorite from "./react/Favorite";
import JQuery from "jquery";
import FavoriteClient from "./lib/Restful/FavoriteClient";
JQuery($ => {
    const logged_in = $('body').is('.logged-in'), $counters = $('.favorite-count');
    FavoriteClient.on('change', (data) => {
        // ※変更時注意：$maxは「functions.php」でも定義している
        const $max = 99;
        if (data.length > ($max)) {
            $counters.text(`${$max}+`);
        }
        else {
            $counters.text(data.length);
        }
    });
    $('.recommend_btn[data-id]').each((index, element) => {
        const node = $(element);
        ReactDOM.render(React.createElement(Favorite, { id: node.data('id'), labels: node.data('labels'), logged_in: logged_in, parent: element }, null), element);
    });
});
